import { Injectable } from '@angular/core';
import { EpHttpService } from '../../../shared/services/epHttpService/epHttp.service';
import { EpEnvironmentService } from '../../../shared/services/epEnvironmentService/ep-environment.service';

@Injectable({
  providedIn: 'root'
})
export class RenewQuoteService {
  constructor(private epHttpService: EpHttpService) { }

  getRenewalQuoteInfoData() {
    const url = `${EpEnvironmentService.baseLocalUrl}/assets/renewQuote/renewQuoteInfo.json`;
    return this.epHttpService.request('GET', url);
  }

  getRenewalSubgroupMedicalDetails(quoteId: string, groupNumber: string) {
    const url = `${EpEnvironmentService.baseUrl}EmployerPlace/api/groups/med/${quoteId}/subgroups?groupNumber=${groupNumber}`;
    return this.epHttpService.request('GET', url);
  }

  getRenewalSubgroupDVDetails(quoteId: string, groupNumber: string, isMedical: boolean) {
    const url =
      `${EpEnvironmentService.baseUrl}EmployerPlace/api/groups/dnv/${quoteId}/subgroups?groupNumber=${groupNumber}&hasMedical=${isMedical}`;
    return this.epHttpService.request('GET', url);
  }

  getConfirmationDetails(quoteId: string) {
    const url = `${EpEnvironmentService.baseUrl}EmployerPlace/api/quotes/${quoteId}/confirmation-details`;
    return this.epHttpService.request('GET', url);
  }

  getSalesConfirmationDetails(quoteId: string) {
    const url = `${EpEnvironmentService.baseUrl}EmployerPlace/api/quotes/${quoteId}/newsales-confirmation-details`;
    return this.epHttpService.request('GET', url);
  }

  getSubGroupConfirmationDetails(groupNumber: string, quoteId: string) {
    const url = `${EpEnvironmentService.baseUrl}Quotes/api/groups/${groupNumber}/documents/${quoteId}/confirmation`;
    return this.epHttpService.request('GET', url);
  }

  updateRenewQuote(param: any) {
    const url = `${EpEnvironmentService.baseUrl}Quotes/api/quotes/renew`;
    return this.epHttpService.request('POST', url, { params: param });
  }

  checkQuoteEligibility(groupNumber: string) {
    const url = `${EpEnvironmentService.baseUrl}Groups/api/groups/${groupNumber}/client/eligibility`;
    return this.epHttpService.request('GET', url);
  }

  updateMemberEnrollment(body: any, quoteType: string) {
    const url = `${EpEnvironmentService.baseUrl}Quotes/api/quotes?quoteType=${quoteType}`;
    return this.epHttpService.request('POST', url, { body });
  }

  setAlternateQuote(body: any, quoteId: string) {
    const url = `${EpEnvironmentService.baseUrl}EmployerPlace/api/quotes/${quoteId}/set-alternate-quote`;
    return this.epHttpService.request('POST', url, { body });
  }

  getMemberInfo(id) {
    const url = `${EpEnvironmentService.baseUrl}EmployerPlace/api/groups/client/${id}/members`;
    return this.epHttpService.request('GET', url);
  }

}
